<template>
  <v-container fluid style="background-color: white">
    <v-row class="mb-4">
      <v-col>
        <v-btn class="bg-gradient-success mr-4" dark @click="_sendRequest"
          >Баталгаажуулаx xүсэлт</v-btn
        >
        <v-btn class="bg-gradient-info mr-4" dark @click="_save"
          >Xадгалаx</v-btn
        >
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="$attrs.classStudents"
      class="elevation-1"
      hide-details
      hide-default-footer
      :items-per-page="-1"
    >
      <template slot="item" slot-scope="props">
        <tr>
          <td style="width: 2%">{{ props.index + 1 }}</td>
          <td>{{ props.item.name }}</td>
          <td>
            <v-text-field v-model="props.item.decisionNo" dense hide-details />
          </td>
          <td>
            <v-select
              :items="decisionOptions"
              v-model="props.item.decision"
              label="Шийдвэр сонгоx"
            />
          </td>

          <td v-if="props.item.decision">
            <v-autocomplete
              :items="decisionReasons"
              v-model="props.item.reasonName"
              label="Шалтгаан сонгоx"
              return-object
              item-text="reasonName"
              item-value="reason_code"
            />
          </td>

          <td v-if="props.item.decision">
            <v-autocomplete
              :items="[]"
              v-model="props.item.newClassGroup"
              label="Шалтгаан сонгоx"
              return-object
              item-text="STUDENT_GROUP_NAME"
              item-value="STUDENT_GROUP_ID"
            />
          </td>
          <td v-if="props.item.newClassGroup">{{ props.item.plan }}</td>
          <td>{{ props.item.date }}</td>
          <td>
            <v-chip color="blue lighten-4" text-color="blue darken-2">
              {{ props.item.status }}
            </v-chip>
          </td>
          <td>-</td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        { text: "№", value: "index" },
        { text: "Суралцагч", value: "name" },
        { text: "Шийдвэрийн №", value: "decisionNo" },
        { text: "Шийдвэр", value: "decision" },
        { text: "Шалтгаан", value: "reasonName" },
        { text: "Дэвших бүлэг", value: "group" },
        { text: "Төлөвлөгөө", value: "plan" },
        { text: "Үйлдлийн огноо", value: "date" },
        { text: "Төлөв", value: "status" },
        { text: "Үйлдэл", value: "action" },
      ],
      decisionOptions: [
        "Дэвшин суралцах",
        "Давтан суралцах",
        "Дэвшин сурахаар гарах",
        "Давтан сурахаар гарах",
      ],
      decisionReasons: [
        {
          code: 1001,
          action: "Дэвшин суралцах",
          reason_code: 78,
          reasonName: "Суралцах түвшин амжилттай дүүргэсэн",
          status: "PROGRESSION",
        },
        {
          code: 1002,
          action: "Давтан суралцах",
          reason_code: 48,
          reasonName: "Эрүүл мэндийн шалтгаанаар",
          status: "ATTEMPT",
        },
        {
          code: 1002,
          action: "Давтан суралцах",
          reason_code: 62,
          reasonName: "Гэмт хэрэгт холбогдсон",
          status: "ATTEMPT",
        },
        {
          code: 1002,
          action: "Давтан суралцах",
          reason_code: 80,
          reasonName: "Амьдралын шаардлагаар",
          status: "ATTEMPT",
        },
        {
          code: 1002,
          action: "Давтан суралцах",
          reason_code: 110,
          reasonName: "Сурлагын амжилт хангалтгүй",
          status: "ATTEMPT",
        },
        {
          code: 1002,
          action: "Давтан суралцах",
          reason_code: 111,
          reasonName: "Хичээл дутуу судалсан",
          status: "ATTEMPT",
        },
        {
          code: 1002,
          action: "Давтан суралцах",
          reason_code: 112,
          reasonName: "Шалгалт өгөөгүй(Төгсөх эсвэл дэвших)",
          status: "ATTEMPT",
        },
        {
          code: 1002,
          action: "Давтан суралцах",
          reason_code: 113,
          reasonName: "Ирэхээ больсон",
          status: "ATTEMPT",
        },
        {
          code: 1002,
          action: "Давтан суралцах",
          reason_code: 128,
          reasonName: "Нас хүрээгүй шалтгаанаар",
          status: "ATTEMPT",
        },
        {
          code: 1002,
          action: "Давтан суралцах",
          reason_code: 130,
          reasonName: "Эцэг, эхийн хүсэлтээр",
          status: "ATTEMPT",
        },
        {
          code: 1006,
          action: "Дэвшин сурахаар гарах",
          reason_code: 2,
          reasonName: "Цэргийн жинхэнэ албанд татагдсан",
          status: "EXIT",
        },
        {
          code: 1006,
          action: "Дэвшин сурахаар гарах",
          reason_code: 16,
          reasonName: "Мэдээллийг буруу оруулсан",
          status: "EXIT",
        },
        {
          code: 1006,
          action: "Дэвшин сурахаар гарах",
          reason_code: 48,
          reasonName: "Эрүүл мэндийн шалтгаанаар",
          status: "EXIT",
        },
        {
          code: 1006,
          action: "Дэвшин сурахаар гарах",
          reason_code: 61,
          reasonName: "Нас барсан",
          status: "EXIT",
        },
        {
          code: 1006,
          action: "Дэвшин сурахаар гарах",
          reason_code: 62,
          reasonName: "Гэмт хэрэгт холбогдсон",
          status: "EXIT",
        },
        {
          code: 1006,
          action: "Дэвшин сурахаар гарах",
          reason_code: 63,
          reasonName: "Ажил эрхлэхээр",
          status: "EXIT",
        },
        {
          code: 1006,
          action: "Дэвшин сурахаар гарах",
          reason_code: 64,
          reasonName: "Сургалтын төлбөр төлөөгүй",
          status: "EXIT",
        },
        {
          code: 1006,
          action: "Дэвшин сурахаар гарах",
          reason_code: 65,
          reasonName: "Сургалтын байгууллагын шийдвэрээр",
          status: "EXIT",
        },
        {
          code: 1006,
          action: "Дэвшин сурахаар гарах",
          reason_code: 67,
          reasonName: "Сурах дургүйгээс",
          status: "EXIT",
        },
        {
          code: 1006,
          action: "Дэвшин сурахаар гарах",
          reason_code: 70,
          reasonName: "Ар гэрийн гачигдал",
          status: "EXIT",
        },
        {
          code: 1006,
          action: "Дэвшин сурахаар гарах",
          reason_code: 75,
          reasonName: "Шилжиж явсан",
          status: "EXIT",
        },
        {
          code: 1006,
          action: "Дэвшин сурахаар гарах",
          reason_code: 77,
          reasonName: "Сахилгын арга хэмжээ авсан",
          status: "EXIT",
        },
        {
          code: 1006,
          action: "Дэвшин сурахаар гарах",
          reason_code: 80,
          reasonName: "Амьдралын шаардлагаар",
          status: "EXIT",
        },
        {
          code: 1006,
          action: "Дэвшин сурахаар гарах",
          reason_code: 97,
          reasonName: "Сураггүй болсон",
          status: "EXIT",
        },
        {
          code: 1006,
          action: "Дэвшин сурахаар гарах",
          reason_code: 99,
          reasonName: "Бусад улс руу шилжиж явсан",
          status: "EXIT",
        },
        {
          code: 1007,
          action: "Давтан сурахаар гарах",
          reason_code: 2,
          reasonName: "Цэргийн жинхэнэ албанд татагдсан",
          status: "EXIT",
        },
        {
          code: 1007,
          action: "Давтан сурахаар гарах",
          reason_code: 16,
          reasonName: "Мэдээллийг буруу оруулсан",
          status: "EXIT",
        },
        {
          code: 1007,
          action: "Давтан сурахаар гарах",
          reason_code: 48,
          reasonName: "Эрүүл мэндийн шалтгаанаар",
          status: "EXIT",
        },
        {
          code: 1007,
          action: "Давтан сурахаар гарах",
          reason_code: 61,
          reasonName: "Нас барсан",
          status: "EXIT",
        },
        {
          code: 1007,
          action: "Давтан сурахаар гарах",
          reason_code: 62,
          reasonName: "Гэмт хэрэгт холбогдсон",
          status: "EXIT",
        },
        {
          code: 1007,
          action: "Давтан сурахаар гарах",
          reason_code: 63,
          reasonName: "Ажил эрхлэхээр",
          status: "EXIT",
        },
        {
          code: 1007,
          action: "Давтан сурахаар гарах",
          reason_code: 64,
          reasonName: "Сургалтын төлбөр төлөөгүй",
          status: "EXIT",
        },
        {
          code: 1007,
          action: "Давтан сурахаар гарах",
          reason_code: 65,
          reasonName: "Сургалтын байгууллагын шийдвэрээр",
          status: "EXIT",
        },
        {
          code: 1007,
          action: "Давтан сурахаар гарах",
          reason_code: 67,
          reasonName: "Сурах дургүйгээс",
          status: "EXIT",
        },
        {
          code: 1007,
          action: "Давтан сурахаар гарах",
          reason_code: 70,
          reasonName: "Ар гэрийн гачигдал",
          status: "EXIT",
        },
        {
          code: 1007,
          action: "Давтан сурахаар гарах",
          reason_code: 75,
          reasonName: "Шилжиж явсан",
          status: "EXIT",
        },
        {
          code: 1007,
          action: "Давтан сурахаар гарах",
          reason_code: 77,
          reasonName: "Сахилгын арга хэмжээ авсан",
          status: "EXIT",
        },
        {
          code: 1007,
          action: "Давтан сурахаар гарах",
          reason_code: 80,
          reasonName: "Амьдралын шаардлагаар",
          status: "EXIT",
        },
        {
          code: 1007,
          action: "Давтан сурахаар гарах",
          reason_code: 97,
          reasonName: "Сураггүй болсон",
          status: "EXIT",
        },
        {
          code: 1007,
          action: "Давтан сурахаар гарах",
          reason_code: 99,
          reasonName: "Бусад улс руу шилжиж явсан",
          status: "EXIT",
        },
      ],
      students: [
        {
          name: "Оюутан 1",
          decisionNo: "01",
          decision: "",
          reasonName: "",
          group: "",
          plan: "",
          date: "",
          status: "Дуусгасан",
        },
        {
          name: "Оюутан 1",
          decisionNo: "01",
          decision: "",
          reasonName: "",
          group: "",
          plan: "",
          date: "",
          status: "Дуусгасан",
        },
        {
          name: "Оюутан 1",
          decisionNo: "01",
          decision: "",
          reasonName: "",
          group: "",
          plan: "",
          date: "",
          status: "Дуусгасан",
        },
        {
          name: "Оюутан 1",
          decisionNo: "01",
          decision: "",
          reasonName: "",
          group: "",
          plan: "",
          date: "",
          status: "Дуусгасан",
        },
        // ...more rows
      ],
    };
  },
  methods: {
    _sendRequest() {
      // this.$swal.fire("Success", "Request sent successfully", "success");
      this.$swal.fire("Xугацаа нь болxоор нээгдэнэ!");
    },
    _save() {
      // this.$swal.fire("Success", "Data saved successfully", "success");
      this.$swal.fire("Xугацаа нь болxоор нээгдэнэ!");
    },
  },
};
</script>
